import React from 'react';
import { Link } from 'react-router-dom';
import Alert from '../Alert';

export default function LoginForm({
  verified, onLogin, onForgotPassword, message,
}) {
  const [password, setPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const onChangePassword = (event) => {
    setPassword(event.target.value);
  };
  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    onLogin({ email, password });
  };
  return (
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="mt-6 text-center text-4xl font-extrabold italic text-blue-600">GING</h1>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={onSubmit}>
            <div>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={onChangeEmail}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>

            <div>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="mt-1">
                <input
                  type="password"
                  required
                  value={password}
                  onChange={onChangePassword}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>

            {
              message && (
              <Alert text={message} type="Error" />
              )
            }
            {
              verified !== '' && (
              <Alert text={verified === 'true' ? 'You can now log in.' : "We couldn't verify your e-mail :/"} type={verified === 'true' ? 'Success' : 'Error'} />
              )
            }

            <div className="flex float-right">

              <div className="text-sm mb-3">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <button
                  className="font-medium text-blue-600 hover:text-blue-500"
                  onClick={onForgotPassword}
                  type="button"
                >
                  Forgot your password?
                </button>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Sign in
              </button>
            </div>
            <p className="font-medium text-gray-900">
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Don't have an account?
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500 pl-3">
                Sign up
              </Link>
            </p>
            <div />
          </form>
        </div>
      </div>
    </div>
  );
}
